<div
  [ngClass]="isEdited ? 'edited' : ''"
  class="cell-renderer-text">

  @if (checkSubDepCode()) {
    <div class="wrap-text">
      @if (hasValidDepartment) {
        <div class="wrap-text">
          @if (params?.colDef?.field === 'dep' && departments) {
            {{ value }}
          }
          @if (params?.colDef?.field === 'depName' && departments) {
            {{ getDepartmentName(params.data.dep) }}
          }
          @if (params?.colDef?.field === 'subDep' && subDepartments) {
            {{ value }}
          }
          @if (params?.colDef?.field === 'subDepName' && subDepartments) {
            {{ getSubDepartmentName(params.data.subDep) }}
          }
        </div>
      } @else {
        <div class="error-text wrap-text">
          This Department Does Not Exist
        </div>
      }
    </div>
  } @else {
    <div class="error-text wrap-text">Please Select A New Sub Department</div>
  }

  @if (isEdited) {
    <app-icon-backspace-outline
      (click)="onUndoButtonClick()"
      [tooltip]="'Previous Value = ' + previousValue">
    </app-icon-backspace-outline>
  }

</div>
